export default __webpack_public_path__ + "assets/images/a07d77f7d70f10590962c4dacd1e543d.svg";